import React from "react";
import MyDataSection from "@/components/MyDataSection";
import { FeedbackNote } from "@/components/shared";
import Tools from "@/components/Tools";

const NekometryTop: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16 bg-background px-4">
      <h1
        className="text-5xl font-bold text-primary-500"
        style={{ fontFamily: "Fredoka, sans-serif" }}
      >
        <ruby>
          Nekometry
          <rt className="text-sm text-primary-600">ネコメトリー</rt>
        </ruby>
      </h1>
      <h2 className="text-xl text-primary-700 mt-4 text-center">
        猫の健康管理をサポートするWebサービス
      </h2>
      <div className="py-4 text-center">
        <p className="text-primary-900">
          Nekometryは、愛猫の健康をサポートするための様々なツールを提供するWebサービスです。
        </p>
        <p className="text-primary-900">
          日々の健康管理に役立つ情報や便利な計算ツールなどを利用できます。
        </p>
        <FeedbackNote />
      </div>
    </div>
  );
};

const Page: React.FC = () => {
  return (
    <>
      <NekometryTop />
      <div className="bg-canvas">
        <Tools />
        <MyDataSection />
      </div>
    </>
  );
};

export default Page;
